import Sidebar from 'components/commons/sidebar'

export const CreateVoting = ({ options, activeSidebar, onChangeSidebar, content }) => {
    return (
        <div className={'flex space-x-6 px-9 py-4 min-h-screen'}>
            <Sidebar
                className={'w-[248px] sticky top-[88px] h-fit'}
                title={'Section Order'}
                options={options}
                activeSidebar={activeSidebar}
                onChange={onChangeSidebar}
            />
            <div className={'w-[calc(100%-272px)] overflow-hidden'}>{content}</div>
        </div>
    )
}
